import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core'

export interface PillItem {
  id: string | number;
  label: string;
  hasContent?: boolean;
}

@Component({
  selector: 'app-pill-nav',
  templateUrl: './pill-nav.component.html',
  styleUrls: ['./pill-nav.component.scss']
})
export class PillNavComponent implements OnInit, OnChanges {

  @Input() entries: Array<PillItem> = [];
  @Input() active: PillItem = null;

  @Output() select = new EventEmitter<PillItem>();

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.entries?.length > 0 && this.active === null) {
      this.onSelect(this.entries[0]);
    }
  }

  public onSelect(entry: PillItem): void {
    this.active = entry;
    this.select.emit(entry);
  }

}
